import React from 'react'

import { DriftUserIF } from '@driftt/app-config/dist/utils/driftTypes'

export type User = DriftUserIF
export type OrgUsersById = Record<number, DriftUserIF | undefined>

export const OrgUsersContext = React.createContext<Record<number, DriftUserIF | undefined>>({})
